import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTypeapplication = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M10.4999 12H13.4999L14.877 15.6467C15.1241 16.3008 14.6407 17 13.9415 17H10.0594C9.36032 17 8.87698 16.301 9.12379 15.647L10.4999 12ZM11.4999 14L10.9999 15H12.9999L12.4999 14H11.4999Z",
			fill: "#E85D78"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M10.9999 23L10.9999 19H12.9999L12.9999 23H10.9999Z",
			fill: "#E85D78"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M15.832 21.0508L14.1679 18.5547L15.832 17.4453L17.4961 19.9414L15.832 21.0508Z",
			fill: "#E85D78"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M6.50382 19.9415L8.16792 17.4453L9.83202 18.5547L8.16792 21.0509L6.50382 19.9415Z",
			fill: "#E85D78"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M5.18927 3.58212C4.7155 2.92036 5.18851 2 6.00238 2H17.9972C18.8111 2 19.2841 2.92034 18.8104 3.5821L13.4999 11H10.4999L5.18927 3.58212ZM7.94297 4L11.5144 9H12.4852L16.0566 4H7.94297Z",
			fill: "#E85D78"
		})
	]
});
export default SvgTypeapplication;
